<template>
  <h3 v-if="getServiceFee" class="text-body-1"
    >Service Fee
    <v-btn x-small icon class="mb-1" v-tooltip="getServiceFeeTooltip">
      <v-icon x-small>mdi-information</v-icon>
    </v-btn>
    :
    <span :class="{ 'service-fee-active-trial': getShopHasActiveTrial }">{{
      getServiceFeeFormatted
    }}</span></h3
  >
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CartServiceFee',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getServiceFee', 'getServiceFeeFormatted']),
    ...mapGetters('shop', ['getShopTitle', 'getShopHasActiveTrial']),
    isTouchEnabled() {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      )
    }, // isTouchEnabled
    tooltipTrigger() {
      return this.isTouchEnabled ? 'click' : 'hover'
    }, // tooltipTrigger
    getServiceFeeTooltip() {
      let popupContent = this.getShopHasActiveTrial
        ? `This shop is enjoying Minimart's free trial so all fees are waived!`
        : `Like ${this.getShopTitle}, Minimart is a self-funded small business run by a tiny team. This service fee allows us to keep our vendor pricing low and, in turn, helps these small businesses thrive.`
      return {
        content: `<div class="service-fee-tooltip caslon--font">
                  <h2 class="popup-title">Minimart Service Fee</h2>
                  <div class="popup-content">${popupContent}</div>
                </div>`,
        html: true,
        placement: 'left',
        triggers: [this.tooltipTrigger],
      }
    }, // getServiceFeeTooltip
  },
}
</script>

<style lang="scss">
.service-fee-tooltip {
  max-width: 250px;
  padding: 7px 5px;
  .popup-title {
    margin-bottom: 5px;
  }
  .popup-content {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }
}
.service-fee-active-trial {
  text-decoration: line-through;
}
</style>
